import { useCallback, useState } from 'react';

/**
 * The owner's login on this browser: the phone they verified and the token
 * the server issued for it. Shared by the owner portal (/owner) and the
 * registration page (/list-your-property), so an owner who is logged in can
 * add a listing without another OTP.
 */
const STORAGE_KEY = 'weotp:owner:session';

export const readOwnerSession = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session || !session.token || !session.phone) return null;
    return { token: String(session.token), phone: String(session.phone) };
  } catch (error) {
    return null;
  }
};

export const saveOwnerSession = (session) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...session, savedAt: Date.now() }));
  } catch (error) {
    // The login just will not survive a reload
  }
};

export const clearOwnerSession = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Nothing to clear
  }
};

const useOwnerSession = () => {
  const [session, setSessionState] = useState(readOwnerSession);

  const setSession = useCallback((next) => {
    if (next) {
      saveOwnerSession(next);
      setSessionState({ token: next.token, phone: next.phone });
    } else {
      clearOwnerSession();
      setSessionState(null);
    }
  }, []);

  return [session, setSession];
};

export default useOwnerSession;
